(function(){
    'use strict';

    angular.module('app').controller('ShareMarginsModalController', ShareMarginsModalController);
    ShareMarginsModalController.$inject = [
        'data',
        'serviceProfileName',
        'totalServiceProfiles',
        'serviceProfileId',
        'networkEffects',
        '$uibModalInstance',
        'ServicesService',
        'toastr'
    ];

    function ShareMarginsModalController(
        data,
        serviceProfileName,
        totalServiceProfiles,
        serviceProfileId,
        networkEffects,
        $uibModalInstance,
        ServicesService,
        toastr
    ) {
        const vm = this;
        vm.serviceProfileName = serviceProfileName;
        vm.totalServiceProfiles = totalServiceProfiles;
        vm.totalSelectedServiceProfiles = networkEffects.length;
        vm.margins = [];
        vm.resellers = data;
        vm.serviceProfileId = serviceProfileId;
        vm.closeModal = closeModal;
        vm.save = save;
        vm.searchMargins = searchMargins;
        vm.sharedResellers = [];

        init();
        function init() {
            preloadData();
        }

        function preloadData() {
            getAllMargins();
        }

        function save() {
            const resellers = [];
            const resellerIds = Object.keys(vm.sharedResellers);

            resellerIds.forEach(data => {
                const margins = vm.sharedResellers[data];
                resellers.push({
                    clientServiceProfileIds: margins.map(data => data.id),
                    resellerId: data
                });
            });
            $uibModalInstance.close(resellers);
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }

        function getAllMargins() {
            ServicesService.getClientServiceLinks(data => {
                vm.resellers.forEach(reseller => {
                    vm.sharedResellers[reseller.id] = [];
                    const foundReseller = networkEffects.find(rs => +rs.resellerId === reseller.id);

                    if (foundReseller) {
                        foundReseller.clientServiceProfileIds.forEach(serviceProfileId => {
                            const foundServiceProfile = data.content.find(serviceProfile => serviceProfile.id === serviceProfileId);
                            if (foundServiceProfile) {
                                vm.sharedResellers[reseller.id].push(foundServiceProfile);
                            }
                        });

                        // select pre select all margins if there is no existing selected margins
                        if (vm.sharedResellers[reseller.id].length < 1) {
                            vm.sharedResellers[reseller.id] = data.content;
                        }
                    }
                });
            }, error => {
                toastr.error('Error', error.message);
            }, {
                serviceProfileId: serviceProfileId,
            });
        }

        function searchMargins(searchTerm) {
            ServicesService.getClientServiceLinks(data => {
                vm.margins = data.content;
            }, error => {
                toastr.error('Error', error.message);
            }, {
                serviceProfileId: serviceProfileId,
                name: searchTerm
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/modal/ShareMarginsModalController.js